import { createFileRoute, redirect } from "@tanstack/react-router";
import { authClient } from "@/auth";
import { Terms } from "@/pages/terms/Terms";

export const Route = createFileRoute("/terms")({
	beforeLoad: async () => {
		const { data: authSession } = await authClient.getSession();

		if (!authSession?.user) {
			throw redirect({ to: "/auth/signin" });
		}

		if (authSession.user.acceptedTermsAt) {
			throw redirect({ to: "/" });
		}

		return { authSession };
	},
	component: Terms,
});
